import { useQSet } from '@exam-management/common/qset-provider';
import { QSetStatus } from '@exam-management/graphql';

import { QSetQuestionWithQuestionList } from '../qset-question-with-question-list';
import { QSetQuestionWithQuestionSnapshotList } from '../qset-question-with-question-snapshot-list';

export default function QSetQuestionDetailsList() {
  const { qSet } = useQSet();
  const isUsingSnapshot = [QSetStatus.Published, QSetStatus.Disabled].includes(qSet.status);

  return isUsingSnapshot ? (
    <QSetQuestionWithQuestionSnapshotList />
  ) : (
    <QSetQuestionWithQuestionList />
  );
}
